import {mapGetters} from "vuex";

export const CardSectionColumnVisibility = {
    computed: {
        ...mapGetters('card', {
            card: 'card',
        }),
        ...mapGetters('card/stages', {
            currentStage: 'currentStage',
            currentNegotiation: 'currentNegotiation',
        }),
    },
    methods: {
        ifShowColumn(columnConfig){
            if( !columnConfig.getVif(this) ){
                return false;
            }

            if (columnConfig.showOnStatuses && columnConfig.showOnStatuses.includes(this.card.status)) {
                return true;
            }

            if( columnConfig.showOnStages ){
                if( this.card.status === this.$constants.card.statuses.STATUS_COMPLETED ){
                    return columnConfig.showOnCompleted;
                }

                if( !this.currentNegotiation ){
                    const showWhileNoNegotiation = columnConfig.showOnStagesWhileNoNegotiation ? columnConfig.showOnStagesWhileNoNegotiation : [];
                    return showWhileNoNegotiation.includes(this.currentStage?.type)
                }

                return columnConfig.showOnStages.includes(this.currentStage?.type);
            }

            return true;
        },
    }
}
